import styled from "styled-components";

export default styled.div`
  background: #ffffff;
  border: 3px solid #2075bc;
  box-sizing: border-box;
  border-radius: 10px;
  padding-left: 20px;
  font-size: 36px;

  max-width: 1040px;
`;
